let requery = (url, query) => {
  let requestUrl = '';
  let arr = [];
  let urls = url.split('?');
  if (urls[1]) {
    arr = urls[1].split('&');
    Object.keys(query).forEach(item => {
      arr.push(`${item}=${query[item]}`);
    });
    requestUrl = `${urls[0]}?${arr.join('&')}`;
  } else {
    Object.keys(query).forEach(item => {
      arr.push(`${item}=${query[item]}`);
    });
    requestUrl = `${urls[0]}?${arr.join('&')}`;
  }
  return requestUrl;
};

export default requery;
